import Cookies from 'yoda-core-components/lib/helpers/Cookies/Cookies';
import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';

function setUserName(name) {
    let value = LocalStorage.getData(name);
    /* istanbul ignore next */
    if (name === 'DP_USER_INFO') {
        value = LocalStorage.getData('DP_USER_NAME');
        value = `${value} | 1`;
    } else if (name === 'USER_ACCT_ID') {
        value = LocalStorage.getData('ACCOUNT_ID');
    } else if (name === 'DYN_USER_ID') {
        value = LocalStorage.getData('ACCOUNT_ID');
    }
    /* istanbul ignore next */
    if (value) {
        Cookies.save(name, value, 2);
    }
}

export default setUserName;
